import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelRetryScheduling} from "../../actions/SubscriptionApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class RetryScheduling extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.retrySubscriptionScheduling({deliveryId: this.props.deliveryId})
      .then((response) => {
        if (response.data.retrySubscriptionScheduling.errors.length <= 0) {
          this.props.cancelRetryScheduling();
        } else {
          let errors = createValidationErrors(response.data.retrySubscriptionScheduling.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRetryScheduling();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Retry scheduling? Please note that stock must be previously reserved for the system to retry scheduling."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const START_DELIVERY = gql`
  mutation retrySubscriptionScheduling($deliveryId: ID!) {
    retrySubscriptionScheduling(deliveryId: $deliveryId) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(START_DELIVERY, {
    props: ({ mutate }) => ({
      retrySubscriptionScheduling: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelRetryScheduling})(withMutation(RetryScheduling));